import basicController from "servicestack/basic.controller.properties";
import TEMPLATE_URL from "emun.customer/picker/apply-retailer-tags-prompt.htm";
import controller from "emun.customer/picker/apply-retailer-tags-prompt.controller";
import open from "webmodals/open";

const NOOP = () => {};

export default ({
  size = "md",
  backdrop = "static",
  templateUrl = TEMPLATE_URL,
  request: {} = {},
  tags = [],
  RetailerIds = [],
  title = `Apply Retailer Tags...`,
} = {}) =>
  open({
    size,
    backdrop,
    templateUrl,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => ({
        title,
        request: {
          RetailerIds,
        }
      })
    }
  }).result;
